export enum ReportPath {
  Questions = "questions",
  Learners = "learners",
}
